import { Button } from "react-migration/components/DeprecatedButton";
import { Loading } from "react-migration/components/Loading";
import { useState } from "react";
import { Alert } from "react-migration/components/Alert";
import { useTitleOwnerQuery } from "react-migration/domains/ownership/apollo/useTitleOwnerQuery";
import { PropertyInfoDetailed } from "react-migration/domains/ownership/components/PropertyInfoDetailed/PropertyInfoDetailed";
import { PropertyInfoSummary } from "react-migration/domains/ownership/components/PropertyInfoSummary";
import { TitleOwner } from "react-migration/domains/ownership/components/TitleOwner";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { SelectionFeature } from "src/js/stores/map/store";
import { showError } from "src/js/stores/user/actions/addNotification";

interface USOwnershipDetailPageProps {
  selection: SelectionFeature;
}

export function USOwnershipDetailPage({ selection }: USOwnershipDetailPageProps) {
  const { t } = useTranslation();
  const [viewDetails, setViewDetails] = useState(false);

  const { titleOwner: title, loading: titleLoading, error: titleError } = useTitleOwnerQuery(selection.id);

  if (titleError) {
    console.error(titleError);
    showError({
      id: `us-ownership-detail-page-error`,
      title: "Error retrieving ownership details",
      description: "An error occurred loading the ownership details. Please try again later.",
      duration: 2000,
    });
  }

  if (titleLoading)
    return (
      <div className="mt-2 mb-6">
        <Loading />
      </div>
    );

  if (!title) {
    return (
      <div className="m-2">
        <Alert.Info>{t("ownership.react.map.sidebar.property_info.main_plot_not_found")}</Alert.Info>
      </div>
    );
  }

  return (
    <div>
      {!viewDetails ? (
        <div className="flex flex-col gap-y-3">
          <PropertyInfoSummary mainTitle={title} action={() => setViewDetails(true)} />
          <TitleOwner mainTitle={title} />
        </div>
      ) : (
        <div>
          <BackButton onClickHandler={() => setViewDetails(false)} />
          {title.id && (
            <div className="flex flex-col gap-y-3">
              <PropertyInfoDetailed propertyId={title.id} parcelId={title.parcel_identifier} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function BackButton({ onClickHandler }: { onClickHandler: () => void }) {
  const { t } = useTranslation();
  return (
    <Button.Secondary className="m-2" onClick={onClickHandler}>
      <i className="icon-lt-arrow-left-s-line" />
      {t("ownership.react.map.sidebar.property_info.back_button")}
    </Button.Secondary>
  );
}
